import React from 'react';
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";

import "../css/OrderProducts.css";
import moment from "moment/moment";
import {SUPPORT_MODAL_HIDE_CREDIT_SALAD, validateCreditSalad} from "../actions";

import { CreditForm } from "./FormikCreditForm";
import {getCreditSubTypeList} from "../../../selectors/credit_modal";

class InternalCreditSaladModal extends React.Component {
  render() {
    const {sub_type_list, modal, hide, validate} = this.props;
    moment.locale('fr');

    const minQuantity = modal.minQuantity || 1;
    const maxQuantity = modal.maxQuantity || 0;

    return <Modal
      show={modal && modal.show}
      animation={false}
      backdrop={true}
      onHide={function() { hide(); }}
      keyboard={true}
    >
      <Modal.Body>
        <h4>{modal.label}</h4>
        {modal.alertWarning &&
          <div className="alert alert-warning" role="alert"><b>{modal.alertWarning}</b></div>
        }
        {modal.alertInfo &&
          <div className="alert alert-info" role="alert">{modal.alertInfo}</div>
        }
        <CreditForm
          sub_type_list={sub_type_list}
          quantity={maxQuantity}
          pricePerUnitQuantity={modal.totalPrice ? modal.totalPrice / modal.quantityBought : 0}
          subtype={modal.subtype}
          labelQuantity="Quantité à recréditer"
          validate={function(values) {
            validate(values.quantity, values.subtype, values.notes, modal);
          }}
          minQuantity={minQuantity}
          maxQuantity={maxQuantity}
        />
      </Modal.Body>
    </Modal>;
  }
}

export const CreditSaladModal = connect(
  function(state) {
    return {
      "modal" : state.support.modalCreditSalad,
      "sub_type_list": getCreditSubTypeList(state),
    };
  },
  function(dispatch) {
    return {
      "hide": function() {
        dispatch({"type": SUPPORT_MODAL_HIDE_CREDIT_SALAD});
      },
      "validate": function(quantity, subtype, notes, modal) {
        dispatch(validateCreditSalad(
          quantity,
          subtype,
          notes,
          modal
        ));
      }
    };
  }
)(InternalCreditSaladModal);
